import { useTranslation } from 'react-i18next'

export default function FlowSvg() {
  const { t } = useTranslation()

  return (
    <svg
      className="block w-full h-auto max-w-[1180px] mx-auto"
      viewBox="0 0 1100 1820"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="jCardGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="100%" stopColor="#F7F9FA" />
        </linearGradient>
        <linearGradient id="jDiamondGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="100%" stopColor="#FEF3E6" />
        </linearGradient>
        <filter id="jSoftShadow" x="-4%" y="-4%" width="108%" height="112%">
          <feDropShadow dx="0" dy="2" stdDeviation="4" floodColor="#1B2B3A" floodOpacity="0.08" />
        </filter>
        <filter id="jDiamondShadow" x="-8%" y="-8%" width="116%" height="116%">
          <feDropShadow dx="0" dy="3" stdDeviation="6" floodColor="#F2994A" floodOpacity="0.15" />
        </filter>
        <marker
          id="jArrow"
          viewBox="0 0 10 10"
          refX="9"
          refY="5"
          markerWidth="8"
          markerHeight="8"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#4A5E6D" />
        </marker>
        <marker
          id="jArrowSim"
          viewBox="0 0 10 10"
          refX="9"
          refY="5"
          markerWidth="8"
          markerHeight="8"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#27AE60" />
        </marker>
        <marker
          id="jArrowNao"
          viewBox="0 0 10 10"
          refX="9"
          refY="5"
          markerWidth="8"
          markerHeight="8"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#EB5757" />
        </marker>
      </defs>

      {/* 1. TRIGGER */}
      <rect
        x="370"
        y="30"
        width="340"
        height="90"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="598" y="42" width="100" height="20" rx="10" fill="#1B2B3A" />
      <text
        x="648"
        y="56"
        textAnchor="middle"
        className="fill-white"
        style={{ fontFamily: 'monospace', fontSize: 9, fontWeight: 600, letterSpacing: 1 }}
      >
        SALESFORCE
      </text>
      <text
        x="540"
        y="82"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 13, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.triggerLine1')}
      </text>
      <text
        x="540"
        y="99"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 13, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.triggerLine2')}
      </text>

      {/* Trigger badge */}
      <rect x="422" y="6" width="236" height="22" rx="11" fill="#00A693" />
      <text
        x="540"
        y="21"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 10,
          fill: '#FFF',
          fontWeight: 700,
          letterSpacing: 1.5,
        }}
      >
        {t('caseJhsf.flow.triggerBadge')}
      </text>

      <line
        x1="540"
        y1="120"
        x2="540"
        y2="170"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* 2. Wait */}
      <circle
        cx="540"
        cy="210"
        r="42"
        fill="#FFF"
        stroke="#F2994A"
        strokeWidth="2"
        strokeDasharray="5,4"
      />
      <text
        x="540"
        y="205"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 10, fill: '#EB5757', fontWeight: 600 }}
      >
        {t('caseJhsf.flow.waitLabel1')}
      </text>
      <text
        x="540"
        y="219"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 10, fill: '#EB5757', fontWeight: 600 }}
      >
        {t('caseJhsf.flow.waitLabel2')}
      </text>

      {/* Split */}
      <line x1="540" y1="252" x2="540" y2="290" stroke="#4A5E6D" strokeWidth="2" />
      <line x1="280" y1="290" x2="800" y2="290" stroke="#4A5E6D" strokeWidth="2" />
      <line
        x1="280"
        y1="290"
        x2="280"
        y2="330"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />
      <line
        x1="800"
        y1="290"
        x2="800"
        y2="330"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* Lane labels */}
      <rect x="155" y="310" width="250" height="26" rx="13" fill="#1B2B3A" />
      <text
        x="280"
        y="328"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 10,
          fill: '#00A693',
          fontWeight: 700,
          letterSpacing: 1.5,
        }}
      >
        {t('caseJhsf.flow.laneA')}
      </text>

      <rect x="675" y="310" width="250" height="26" rx="13" fill="#1B2B3A" />
      <text
        x="800"
        y="328"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 10,
          fill: '#00A693',
          fontWeight: 700,
          letterSpacing: 1.5,
        }}
      >
        {t('caseJhsf.flow.laneB')}
      </text>

      {/* Lane divider */}
      <line
        x1="540"
        y1="340"
        x2="540"
        y2="1180"
        stroke="#E2E8ED"
        strokeWidth="1"
        strokeDasharray="6,4"
      />

      {/* ===== TRILHA A ===== */}
      <line
        x1="280"
        y1="336"
        x2="280"
        y2="380"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* A1 WhatsApp corretor */}
      <rect
        x="130"
        y="385"
        width="300"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="328" y="397" width="90" height="20" rx="10" fill="#25D366" />
      <text
        x="373"
        y="411"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.a1Badge')}
      </text>
      <text
        x="280"
        y="437"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.a1Line1')}
      </text>
      <text
        x="280"
        y="454"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.a1Line2')}
      </text>

      <line
        x1="280"
        y1="470"
        x2="280"
        y2="510"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* A Decision */}
      <polygon
        points="280,510 390,575 280,640 170,575"
        fill="url(#jDiamondGrad)"
        stroke="#F2994A"
        strokeWidth="2.5"
        filter="url(#jDiamondShadow)"
        strokeLinejoin="round"
      />
      <text
        x="280"
        y="570"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 12,
          fill: '#2C3E50',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.flow.a1DecisionLine1')}
      </text>
      <text
        x="280"
        y="585"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 12,
          fill: '#2C3E50',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.flow.a1DecisionLine2')}
      </text>

      {/* NAO loop */}
      <circle
        cx="80"
        cy="500"
        r="40"
        fill="#FFF"
        stroke="#EB5757"
        strokeWidth="2"
        strokeDasharray="5,4"
      />
      <text
        x="80"
        y="496"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 10, fill: '#EB5757', fontWeight: 600 }}
      >
        {t('caseJhsf.flow.a1WaitLabel1')}
      </text>
      <text
        x="80"
        y="509"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 10, fill: '#EB5757', fontWeight: 600 }}
      >
        {t('caseJhsf.flow.a1WaitLabel2')}
      </text>

      <text
        x="146"
        y="565"
        style={{
          fontFamily: 'monospace',
          fontSize: 11,
          fill: '#EB5757',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        NAO
      </text>
      <path d="M 170 575 L 80 575 L 80 542" fill="none" stroke="#EB5757" strokeWidth="2" />
      <path
        d="M 80 460 L 80 405 L 130 405"
        fill="none"
        stroke="#EB5757"
        strokeWidth="2"
        markerEnd="url(#jArrowNao)"
      />

      {/* Retry note */}
      <rect
        x="10"
        y="430"
        width="140"
        height="30"
        rx="6"
        fill="#FDECEC"
        stroke="#EB5757"
        strokeWidth="1"
        opacity="0.85"
      />
      <text
        x="80"
        y="450"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#EB5757', fontWeight: 600 }}
      >
        {t('caseJhsf.flow.a1RetryNote')}
      </text>

      {/* SIM */}
      <text
        x="292"
        y="666"
        style={{
          fontFamily: 'monospace',
          fontSize: 11,
          fill: '#27AE60',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        SIM
      </text>
      <line
        x1="280"
        y1="640"
        x2="280"
        y2="690"
        stroke="#27AE60"
        strokeWidth="2"
        markerEnd="url(#jArrowSim)"
      />

      {/* A2 AI Agent */}
      <rect
        x="130"
        y="695"
        width="300"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="318" y="707" width="100" height="20" rx="10" fill="#8B5CF6" />
      <text
        x="368"
        y="721"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.a2Badge')}
      </text>
      <text
        x="280"
        y="747"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.a2Line1')}
      </text>
      <text
        x="280"
        y="764"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.a2Line2')}
      </text>

      <line
        x1="280"
        y1="780"
        x2="280"
        y2="830"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* A3 Salesforce */}
      <rect
        x="130"
        y="835"
        width="300"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="328" y="847" width="90" height="20" rx="10" fill="#1B2B3A" />
      <text
        x="373"
        y="861"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        SALESFORCE
      </text>
      <text
        x="280"
        y="887"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.a3Line1')}
      </text>
      <text
        x="280"
        y="904"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.a3Line2')}
      </text>

      <line
        x1="280"
        y1="920"
        x2="280"
        y2="970"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* A4 Update Lead */}
      <rect
        x="130"
        y="975"
        width="300"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="328" y="987" width="90" height="20" rx="10" fill="#1B2B3A" />
      <text
        x="373"
        y="1001"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        SALESFORCE
      </text>
      <text
        x="280"
        y="1027"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.a4Line1')}
      </text>
      <text
        x="280"
        y="1044"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.a4Line2')}
      </text>

      {/* Extract annotation */}
      <rect
        x="10"
        y="720"
        width="100"
        height="50"
        rx="6"
        fill="#F3E8FD"
        stroke="#8B5CF6"
        strokeWidth="1"
      />
      <text
        x="60"
        y="740"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#8B5CF6',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.extractLabel')}
      </text>
      <text
        x="60"
        y="754"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.extractLine1')}
      </text>
      <text
        x="60"
        y="765"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.extractLine2')}
      </text>

      {/* ===== TRILHA B ===== */}
      <line
        x1="800"
        y1="336"
        x2="800"
        y2="380"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* B1 WhatsApp cliente */}
      <rect
        x="650"
        y="385"
        width="300"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="848" y="397" width="90" height="20" rx="10" fill="#25D366" />
      <text
        x="893"
        y="411"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.b1Badge')}
      </text>
      <text
        x="800"
        y="437"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b1Line1')}
      </text>
      <text
        x="800"
        y="454"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b1Line2')}
      </text>

      {/* Questions annotation */}
      <rect
        x="960"
        y="400"
        width="130"
        height="75"
        rx="6"
        fill="#E8FDE8"
        stroke="#27AE60"
        strokeWidth="1"
      />
      <text
        x="1025"
        y="417"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#27AE60',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.b1QuestionsLabel')}
      </text>
      <text
        x="1025"
        y="432"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b1Q1')}
      </text>
      <text
        x="1025"
        y="444"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b1Q2')}
      </text>
      <text
        x="1025"
        y="456"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b1Q3')}
      </text>
      <text
        x="1025"
        y="468"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b1Q4')}
      </text>

      <line
        x1="800"
        y1="470"
        x2="800"
        y2="510"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* B Decision */}
      <polygon
        points="800,510 910,575 800,640 690,575"
        fill="url(#jDiamondGrad)"
        stroke="#F2994A"
        strokeWidth="2.5"
        filter="url(#jDiamondShadow)"
        strokeLinejoin="round"
      />
      <text
        x="800"
        y="570"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 12,
          fill: '#2C3E50',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.flow.b1DecisionLine1')}
      </text>
      <text
        x="800"
        y="585"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 12,
          fill: '#2C3E50',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.flow.b1DecisionLine2')}
      </text>

      {/* NAO reminder */}
      <circle
        cx="1040"
        cy="575"
        r="40"
        fill="#FFF"
        stroke="#EB5757"
        strokeWidth="2"
        strokeDasharray="5,4"
      />
      <text
        x="1040"
        y="571"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 10, fill: '#EB5757', fontWeight: 600 }}
      >
        {t('caseJhsf.flow.b1WaitLabel1')}
      </text>
      <text
        x="1040"
        y="584"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 10, fill: '#EB5757', fontWeight: 600 }}
      >
        {t('caseJhsf.flow.b1WaitLabel2')}
      </text>

      <text
        x="935"
        y="565"
        style={{
          fontFamily: 'monospace',
          fontSize: 11,
          fill: '#EB5757',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        NAO
      </text>
      <path d="M 910 575 L 998 575" fill="none" stroke="#EB5757" strokeWidth="2" />

      {/* SIM */}
      <text
        x="812"
        y="666"
        style={{
          fontFamily: 'monospace',
          fontSize: 11,
          fill: '#27AE60',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        SIM
      </text>
      <line
        x1="800"
        y1="640"
        x2="800"
        y2="690"
        stroke="#27AE60"
        strokeWidth="2"
        markerEnd="url(#jArrowSim)"
      />

      {/* B2 AI Agent */}
      <rect
        x="650"
        y="695"
        width="300"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="838" y="707" width="100" height="20" rx="10" fill="#8B5CF6" />
      <text
        x="888"
        y="721"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.b2Badge')}
      </text>
      <text
        x="800"
        y="747"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b2Line1')}
      </text>
      <text
        x="800"
        y="764"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b2Line2')}
      </text>

      <line
        x1="800"
        y1="780"
        x2="800"
        y2="830"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* B3 Salesforce */}
      <rect
        x="650"
        y="835"
        width="300"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="848" y="847" width="90" height="20" rx="10" fill="#1B2B3A" />
      <text
        x="893"
        y="861"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        SALESFORCE
      </text>
      <text
        x="800"
        y="887"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b3Line1')}
      </text>
      <text
        x="800"
        y="904"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b3Line2')}
      </text>

      <line
        x1="800"
        y1="920"
        x2="800"
        y2="970"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* B4 NPS */}
      <rect
        x="650"
        y="975"
        width="300"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="848" y="987" width="90" height="20" rx="10" fill="#1B2B3A" />
      <text
        x="893"
        y="1001"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        SALESFORCE
      </text>
      <text
        x="800"
        y="1027"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b4Line1')}
      </text>
      <text
        x="800"
        y="1044"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b4Line2')}
      </text>

      {/* CRM annotation */}
      <rect
        x="960"
        y="855"
        width="130"
        height="50"
        rx="6"
        fill="#E8F4FD"
        stroke="#2D9CDB"
        strokeWidth="1"
      />
      <text
        x="1025"
        y="873"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#2D9CDB',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.b3AnnotLabel')}
      </text>
      <text
        x="1025"
        y="887"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b3AnnotLine1')}
      </text>
      <text
        x="1025"
        y="899"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.b3AnnotLine2')}
      </text>

      {/* ===== CONVERGENCE ===== */}
      <line x1="280" y1="1060" x2="280" y2="1100" stroke="#4A5E6D" strokeWidth="2" />
      <line x1="800" y1="1060" x2="800" y2="1100" stroke="#4A5E6D" strokeWidth="2" />
      <line x1="280" y1="1100" x2="800" y2="1100" stroke="#4A5E6D" strokeWidth="2" />
      <line
        x1="540"
        y1="1100"
        x2="540"
        y2="1140"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      <rect
        x="440"
        y="1085"
        width="200"
        height="22"
        rx="11"
        fill="#E0F5F2"
        stroke="#00A693"
        strokeWidth="1"
      />
      <text
        x="540"
        y="1100"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#007D6E',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.mergeLabel')}
      </text>

      {/* Recalculate */}
      <rect
        x="370"
        y="1145"
        width="340"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="598" y="1157" width="100" height="20" rx="10" fill="#F2994A" />
      <text
        x="648"
        y="1171"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        SCORING
      </text>
      <text
        x="540"
        y="1197"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 13, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.scoreLine1')}
      </text>
      <text
        x="540"
        y="1214"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 13, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.scoreLine2')}
      </text>

      <line
        x1="540"
        y1="1230"
        x2="540"
        y2="1270"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jArrow)"
      />

      {/* Score decision */}
      <polygon
        points="540,1270 660,1340 540,1410 420,1340"
        fill="url(#jDiamondGrad)"
        stroke="#F2994A"
        strokeWidth="2.5"
        filter="url(#jDiamondShadow)"
        strokeLinejoin="round"
      />
      <text
        x="540"
        y="1332"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 12,
          fill: '#2C3E50',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.flow.scoreDecisionLine1')}
      </text>
      <text
        x="540"
        y="1350"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 12,
          fill: '#2C3E50',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.flow.scoreDecisionLine2')}
      </text>

      {/* SIM: notify */}
      <text
        x="552"
        y="1436"
        style={{
          fontFamily: 'monospace',
          fontSize: 11,
          fill: '#27AE60',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        SIM
      </text>
      <line
        x1="540"
        y1="1410"
        x2="540"
        y2="1465"
        stroke="#27AE60"
        strokeWidth="2"
        markerEnd="url(#jArrowSim)"
      />

      <rect
        x="370"
        y="1470"
        width="340"
        height="85"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jSoftShadow)"
      />
      <rect x="588" y="1482" width="110" height="20" rx="10" fill="#25D366" />
      <text
        x="643"
        y="1496"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#FFF',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        WHATSAPP
      </text>
      <text
        x="540"
        y="1520"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 13, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.notifyLine1')}
      </text>
      <text
        x="540"
        y="1537"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 13, fill: '#2C3E50', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.notifyLine2')}
      </text>

      {/* NAO: silent */}
      <text
        x="692"
        y="1328"
        style={{
          fontFamily: 'monospace',
          fontSize: 11,
          fill: '#EB5757',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        NAO
      </text>
      <path d="M 660 1340 L 860 1340 L 860 1500" fill="none" stroke="#EB5757" strokeWidth="2" />

      <rect
        x="770"
        y="1480"
        width="190"
        height="50"
        rx="10"
        fill="url(#jCardGrad)"
        stroke="#E2E8ED"
        strokeWidth="1.5"
      />
      <text
        x="865"
        y="1502"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 11, fill: '#4A5E6D', fontWeight: 600 }}
      >
        {t('caseJhsf.flow.silentLine1')}
      </text>
      <text
        x="865"
        y="1518"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 11, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.silentLine2')}
      </text>

      {/* Final convergence */}
      <line x1="540" y1="1555" x2="540" y2="1590" stroke="#4A5E6D" strokeWidth="2" />
      <line x1="865" y1="1530" x2="865" y2="1590" stroke="#4A5E6D" strokeWidth="2" />
      <line
        x1="540"
        y1="1590"
        x2="865"
        y2="1590"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        strokeDasharray="4,3"
      />

      {/* END */}
      <rect x="610" y="1610" width="190" height="45" rx="22" fill="#1B2B3A" />
      <text
        x="705"
        y="1638"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 13,
          fill: '#00A693',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.endLabel')}
      </text>

      {/* Top annotation */}
      <rect
        x="10"
        y="45"
        width="220"
        height="60"
        rx="8"
        fill="#E0F5F2"
        stroke="#00A693"
        strokeWidth="1"
      />
      <text
        x="120"
        y="68"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#007D6E',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.bookingAnnotLabel')}
      </text>
      <text
        x="120"
        y="88"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 10, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.bookingAnnotLine')}
      </text>

      {/* Broker message annotation */}
      <rect
        x="10"
        y="405"
        width="110"
        height="35"
        rx="6"
        fill="#E8FDE8"
        stroke="#27AE60"
        strokeWidth="1"
      />
      <text
        x="65"
        y="420"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#27AE60',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.flow.msgAnnotLabel')}
      </text>
      <text
        x="65"
        y="432"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 8, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.flow.msgAnnotLine')}
      </text>
    </svg>
  )
}
